<template>
  <tab-content
    title="Validate"
    :before-change="submit"
    @active="validate()"
  >
    <div
      v-if="!showResult(validationResult)"
      class="d-flex justify-content-center"
    >
      <b-spinner
        variant="danger"
        label="Loading..."
      />
    </div>
    <div
      v-else-if="!isInValid(validationResult)"
      class="d-flex align-items-center flex-column"
    >
      <h1>
        <font-awesome-icon
          class="faa-bounce animated"
          :style="{color: 'green'}"
          icon="check-circle"
          size="lg"
        />
      </h1>
      <p>Validation successful: no changes identified</p>
    </div>
    <UpdateValidateWarning
      v-else
      :result="validationResult"
      :ignore="ignoreValidateWarning"
      @ignore="ignoreValidateWarning=true"
    />
  </tab-content>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { getValidationResult } from '@/api'
import UpdateValidateWarning from '@/components/admin/upload/UpdateValidateWarning.vue'

const components = {
  UpdateValidateWarning,
}

@Component({ components })
export default class UpdateValidate extends Vue {
  ignoreValidateWarning = false
  validationResult: Record<string, any> = {}

  get from () {
    return this.$router.currentRoute.query.fromVersionId as string
  }

  get to () {
    return this.$router.currentRoute.params.primaryVersionId
  }

  async validate () {
    this.validationResult = await getValidationResult(this.from, this.to)
    this.ignoreValidateWarning = !this.isInValid(this.validationResult)
  }

  showResult (result: Record<string, any>) {
    return Object.keys(result).length > 0
  }

  isInValid (result: Record<string, any>) {
    return result.invalid || result['missing branches'].length > 0 || result['new branches'].length > 0 || result['missing headings'].length > 0 || result['new headings'].length > 0
  }

  submit () {
    return this.ignoreValidateWarning
  }
}

</script>
